import React from 'react'
import CourseSection from '../components/Courses/CourseSection'
import AllCourses from '../components/All Courses/AllCourses'
import CourseDesc from '../components/All Courses/CourseDesc'

const CoursesPage = () => {
    return (
        <div>
            <AllCourses />
        </div>
    )
}

export default CoursesPage
